import functions from "./functions";

$(function() { 
    let $newsletter = $('form.newsletter')

    if ( ! $newsletter.length) return;
    let newsletter = $newsletter[0]
    $newsletter.on('submit', e => {
        e.preventDefault();

        $newsletter.addClass('processing');
        
        let params = {};
        $.each($newsletter.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();

        params['recaptchaType'] = 'enterprise';

        grecaptcha.enterprise.ready(function () {
            grecaptcha.enterprise.execute(functions.getRecaptchaKey(), { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);

                $.post('/services/mailchimp/', params).then(response => {
                   let $elem = $newsletter.parent();
                    $elem.find('.newsletter').addClass('d-none');
                    $elem.removeClass('processing');
                    $elem.find(".done-message").html(response.data).removeClass('d-none').addClass(response.status ? 'bg-warning' : 'bg-danger');

                    setTimeout(() => { 
                        $elem.find('.newsletter').removeClass('d-none');  
                        $elem.find(".done-message").html('').addClass('d-none').removeClass("bg-warning, bg-danger");
                    }, 4000);

                    if (response.status == true) {
                        newsletter.reset();
                    }
                });
            });
        });
    });
})